export enum VisualizationMode {
  standard = 1,
  card = 2,
}
